import { Stack } from '@nautilusbio/nb-design-system/Stack';
import { Text } from '@nautilusbio/nb-design-system/Text';
import { Tooltip } from '@nautilusbio/nb-design-system/Tooltip';
import React from 'react';
import type { FC } from 'react';

export type OrgCellProps = {
  orgIds: string[];
  orgNameMap: Map<string, string>;
};

const OrgCell: FC<OrgCellProps> = ({ orgIds, orgNameMap }) => {
  const names = orgIds.map(id => orgNameMap.get(id) ?? id);

  if (names.length === 0) return <Text as="span">—</Text>;
  if (names.length === 1) return <Text as="span">{names[0]}</Text>;

  return (
    <Tooltip
      content={
        <Stack gap={2} orientation="vertical">
          {orgIds.map((id, i) => (
            <Text as="span" key={id}>
              {names[i]}
            </Text>
          ))}
        </Stack>
      }
      placement="bottom"
      trigger={
        <Text as="span">
          {names[0]} +{names.length - 1}
        </Text>
      }
      triggerProps={{ tabIndex: 0 }}
    />
  );
};

export default OrgCell;
